import { Message } from 'types/messages';

export default function isArrayMessage<M extends Message>(
  message: M | Array<M>
): message is Array<M> {
  return Object.prototype.toString.call(message) === '[object Array]';
}
